import React, { useState } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
const TITLE = "تحويل الارقام من انجليزي الى عربي";
const DESCRIPTION =
  "استخدم أداة تحويل الأرقام لتحويل الأرقام من النظام الإنجليزي إلى النظام العربي بسرعة وسهولة. أدخل الأرقام الإنجليزية في الحقل المخصص لتحويلها تلقائيًا إلى الأرقام العربية، مما يجعل التعامل مع الأرقام في السياقات التي تتطلب الأرقام العربية أسهل وأكثر فعالية.";
const KEYWORDS =
  "تحويل الأرقام, الأرقام الإنجليزية, الأرقام العربية, تحويل الأرقام من إنجليزي إلى عربي, أداة تحويل الأرقام";
const OG_URL = "https://do-calculate.com/calculator/ar/english-to-arabic/";
const englishToArabic = (englishNum) => {
  const arabicNumbers = "٠١٢٣٤٥٦٧٨٩";
  const englishNumbers = "0123456789";
  return englishNum
    .split("")
    .map((char) =>
      englishNumbers.indexOf(char) !== -1
        ? arabicNumbers[englishNumbers.indexOf(char)]
        : char
    )
    .join("");
};
const EnglishToArabicConverter = () => {
  const [input, setInput] = useState("");
  const [converted, setConverted] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (input) {
        const result = englishToArabic(input);
        setConverted(result);
        setError("");
      } else {
        throw new Error("يرجى إدخال رقم عربي.");
      }
    } catch (err) {
      setError(err.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>
              محول الأرقام - من الانجليزيه إلى العربية
            </h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  أداة تحويل الأرقام من الإنجليزية إلى العربية توفر لك طريقة
                  سريعة وسهلة لتحويل الأرقام من النظام الإنجليزي إلى النظام
                  العربي. كل ما عليك فعله هو إدخال الأرقام الإنجليزية في الحقل
                  المخصص، وستقوم الأداة بتحويلها تلقائيًا إلى الأرقام العربية.
                  هذه الأداة مفيدة بشكل خاص عند العمل مع مستندات أو بيانات تحتاج
                  إلى الأرقام العربية أو عند إدخال الأرقام في السياقات التي
                  تستخدم النظام العربي.
                </p>
                <p>
                  <strong>كيفية استخدام الأداة:</strong>
                </p>
                <ul>
                  <li>
                    أدخل الأرقام المكتوبة بالأرقام الإنجليزية في الحقل المخصص.
                  </li>
                  <li>اضغط على زر "تحويل" للحصول على الأرقام العربية.</li>
                  <li>ستظهر النتيجة فورًا في الحقل المخصص للتحويل.</li>
                </ul>
                <p>
                  باستخدام هذه الأداة، يمكنك تسريع عملية تحويل الأرقام وتجنب
                  الأخطاء التي قد تحدث عند التحويل يدويًا. تعد الأداة مثالية
                  للاستخدام في الأعمال التجارية، التعليم، أو أي مجال آخر يتطلب
                  التعامل مع أنظمة أرقام متعددة.
                </p>
              </div>
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>محول الأرقام</h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          أدخل الأرقام الانجليزية:
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="أدخل رقم انجليزي"
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        className="form-control"
                        style={{ width: "50%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                    <br />
                    { error && (
                      <p style={{ color: "red" }}>{error}</p>
                    )}
                    <br />
                    { converted && (
                      <div className="p-3 mb-2 bg-success text-white">
                        <hr />
                        <p>النتيجة:</p>
                        <p>
                          الرقم العربي: <b>{converted}</b>
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      {" "}
    </div>
  );
};
export default EnglishToArabicConverter;
